"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var event_1 = require("./event");
function useEvent(e, fn, once) {
    if (once === void 0) { once = false; }
    var method = once ? 'once' : 'on';
    var off = react_1.useCallback(function () {
        event_1.EventCenter.off(e, fn);
    }, [e, fn]);
    react_1.useEffect(function () {
        event_1.EventCenter[method](e, fn);
        return off;
    }, [e, fn, method, off]);
    return react_1.useMemo(function () {
        return [
            function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                event_1.EventCenter.emit.apply(event_1.EventCenter, [e].concat(args));
            },
            off
            // @IMP: as - 虽然不知道为什么，但是这修复了 emit 类型推断不正常的问题
        ];
    }, [e, off]);
}
exports.useEvent = useEvent;
//# sourceMappingURL=useEvent.js.map